import api from '../axios.config';
import {Buffer} from 'buffer';
import dayjs from 'dayjs';

/**
 * Permet de se connecter
 * @param {*} email email
 * @param {*} password password
 * @return {JSX}
 */
export async function login(email, password) {
  const res = await api.post('/auth/login', {
    email: email,
    password: password,
  });
  return res.data;
}

/**
 * Permet de se déconnecter
 * @return {JSX}
 */
export async function logout() {
  const res = await api.post('/auth/logout');
  window.location.href = '/login';
  localStorage.removeItem('accessToken');
  localStorage.removeItem('connUser');
  return res.data.data;
}

/**
 * Permet de get la liste des chantiers
 * @return {JSX}
 */
export async function getChantier() {
  const res = await api.get('/places');
  return res.data.data;
}

/**
 * Permet de recevoir les informations d'un chantier
 * @param {*} id id du chantier
 * @return {JSX}
 */
export async function getChantierId(id) {
  const res = await api.get('/places/' + id);
  return res.data;
}

/**
 * Permet de recevoir les informations d'un chantier
 * @param {*} id id du chantier
 * @return {JSX}
 */
export async function getChantierIdInfo(id) {
  const res = await api.get('/places/info/' + id);
  return res.data;
}

/**
 * Permet de get la liste de factures
 * @return {JSX}
 */
export async function getFacture() {
  const res = await api.get('/factures');
  return res.data.data;
}

/**
 * Permet de recevoir la liste de nom des chantier dans l'historique
 * @return {JSX}
 */
export async function getPlaceNameHistory() {
  const res = await api.get('/places/namehistory');
  return res.data;
}

/**
 * Permet de recevoir la liste de toutes les nom de chantiers
 * @return {JSX}
 */
export async function getPlaceNameAll() {
  const res = await api.get('/places/nameall');
  return res.data;
}

/**
 * Permet de recevoir la liste de photos d'un chantier
 * @param {*} idchantier id du chantier
 * @return {JSX}
 */
export async function getPhoto(idchantier) {
  const res = await api.get('/photos/' + idchantier);
  return res.data.data;
}

/**
 * Update les extras des photos
 * @param {*} id id
 * @param {*} body body
 */
export async function updatePhotoExtra(id, body) {
  await api.put('/photos/' + id + '/extra', {
    extra1: body.extra1,
    extra2: body.extra2,
    extra3: body.extra3,
    avancement: body.avancement,
  });
}

/**
 * Permet de se connecter au oneDrive
 * @param {*} id id du user
 */
export async function onedrive(id) {
  const authUrl = process.env.REACT_APP_SERVERIP + '/api/photos/redirectmicrosoft/' + id;
  window.location.href = authUrl;
}

/**
 * Permet de recevoir toutes les checkin d'une semaine
 * @param {*} week la semaine
 * @param {*} user la user
 * @return {JSX}
 */
export async function getStartEnd(week, user) {
  const res = await api.get('/startends?week=' + week + '&user=' + user);
  return res.data.data;
}

/**
 * Permet de recevoir la liste de tâches
 * @return {JSX}
 */
export async function getTaches() {
  const res = await api.get('/taches');
  return res.data;
}

/**
 * Permet de recevoir la liste de users
 * @return {JSX}
 */
export async function getUsers() {
  const res = await api.get('/users');
  return res.data;
}

/**
 * Supprimer un chckin
 * @param {*} id id du checkin
 * @return {JSX}
 */
export async function deleteStartEnd(id) {
  const res = await api.delete('/startends/' + id);
  return res;
}

/**
 * Modifier un checkin
 * @param {*} id id du checkin
 * @param {*} body les information à modifier
 * @param {*} taches la liste de tâches
 * @return {JSX}
 */
export async function updateStartend(id, body, taches) {
  const res = await api.put('/startends/' + id, {
    place_id: body.chantier.value,
    note: body.note,
    date: body.date,
    employer: body.employer,
    from: body.checkin,
    to: body.checkout,
    taches: taches,
    transport: body.transport,
    extra1: body.extra1,
    extra2: body.extra2,
    extra3: body.extra3,
  });
  return res;
}

/**
 * Ajouter un checkin
 * @param {*} body Informations à modifier
 * @param {*} taches La liste de tâches
 * @param {*} employerCheckinId employerCheckinId
 * @return {JSX}
 */
export async function addStartend(body, taches, employerCheckinId) {
  const res = await api.post('/startends', {
    place_id: body.chantier.value,
    note: body.note,
    date: body.date,
    employer: body.employer,
    from: body.checkinConverted,
    to: body.checkoutConverted,
    taches: taches,
    transport: body.transport,
    extra1: body.extra1,
    extra2: body.extra2,
    extra3: body.extra3,
    user_id: employerCheckinId});
  return res;
}

/**
 * Permet d'allez recevoir la liste de tâches d'un chantier
 * @param {*} placeId le id du chantier
 * @return {JSX}
 */
export async function getTachesGraph(placeId) {
  const res = await api.get('/hourtaches/' + placeId);
  return res;
}

/**
 * Les heures de la semaine
 * @param {*} week La semaine
 * @param {*} user user
 * @return {JSX}
 */
export async function getHeuresSemaine(week, user) {
  const res = await api.get('weeks?week=' + week + '&user=' + user);
  return res.data;
}

/**
 * Permet de recevoir les informations d'un checkin
 * @param {*} id id du checkin
 * @return {JSX}
 */
export async function getCheckin(id) {
  const res = await api.get('startends/' + id);
  return res.data.data;
}

/**
 * recoit tous les checkin d'un chantier
 * @param {*} id id
 * @return {*}
 */
export async function getCheckinChantier(id) {
  const res = await api.get('places/' + id + '/startends');
  return res.data.data;
}

/**
 * supprime un chantier
 * @param {*} id id du chantier
 */
export async function deleteChantier(id) {
  await api.delete('/places/' + id);
}

/**
 * Modifier un chantier
 * @param {*} id id du chantier
 * @param {*} form information à modifier
 */
export async function updateChantier(id, form) {
  await api.put('/places/' + id,
      {
        client_name: form.client_name,
        name: form.name,
        phone: form.phone,
        contrat: form.contrat,
      });
}

/**
 * Ajouter un chantier
 * @param {*} form information du chantier
 * @return {JSX}
 */
export async function addChantier(form) {
  const res = await api.post('/places/',
      {
        client_name: form.client_name,
        name: form.name,
        phone: form.phone,
        contrat: form.contrat,
      });
  return res.data;
}

/**
 * Supprime une facture
 * @param {*} id id de la facture
 */
export async function deleteFacture(id) {
  await api.delete('/factures/' + id);
}

/**
 * Modifie une facture
 * @param {*} id id de la facture
 * @param {*} name nom de la facture
 * @return {JSX}
 */
export async function updateFacture(id, name) {
  const res = await api.put('/factures/' + id,
      {name: name});
  return res.data.data;
}

/**
 * Ajouter une facture
 * @param {*} name nom de la facture
 * @return {JSX}
 */
export async function addFacture(name) {
  const res = await api.post('/factures',
      {name: name});
      
  return res.data.data;
}

/**
 * Recoir la liste de tâches
 * @return {JSX}
 */
export async function getAllTache() {
  const res = await api.get('/taches/getall');
  return res.data.data;
}

/**
 * Supprimer une tâche
 * @param {*} id id de la tâche
 */
export async function deleteTache(id) {
  await api.delete('/taches/' + id);
}

/**
 * Modifier un tâche
 * @param {*} id id de la tâche
 * @param {*} name nom de la tâche
 * @param {*} color color de la tache
 * @return {JSX}
 */
export async function updateTache(id, name, color) {
  const res = await api.put('/taches/' + id,
      {name: name,
        color: color});
  return res.data.data;
}

/**
 * Ajouter uen tâche
 * @param {*} name nom de la tâche
 * @param {*} color color
 * @return {JSX}
 */
export async function addTache(name, color) {
  const res = await api.post('/taches',
      {name: name,
        color: color});
  return res.data.data;
}

/**
 * Recoit la liste des users
 * @return {JSX}
 */
export async function getEmploye() {
  const res = await api.get('/users/all');
  return res.data.data;
}

/**
 * Ajouter un user
 * @param {*} form form
 * @return {JSX}
 */
export async function addEmploye(form) {
  const res = await api.post('/users',
      {name: form.name,
        email: form.email,
        default_hours: form.default_hours,
        default_minutes: form.default_minutes,
        password: form.password,
        confirmPassword: form.confirmPassword,
        is_admin: form.is_admin,
      });

  return res.data;
}

/**
 * Modifier un user
 * @param {*} id id du user
 * @param {*} form form
 * @return {JSX}
 */
export async function updateEmploye(id, form) {
  const res = await api.put('/users/' + id,
      {name: form.name,
        email: form.email,
        default_hours: form.default_hours,
        default_minutes: form.default_minutes,
        password: form.password === '' ? null: form.password,
        confirmPassword: form.confirmPassword === '' ? null : form.confirmPassword,
        is_admin: form.is_admin,
      });
  return res.data;
}

/**
 * Permet de savoir si un user travaille encore
 * @param {*} id id du user
 * @return {JSX}
 */
export async function stillWorkingEmploye(id) {
  const res = await api.put('/users/working/'+ id);
  return res.data.data;
}

/**
 * Permet de recevoir les information des tâches, users et factures en même temps
 * @return {JSX}
 */
export async function adminInfo() {
  const promiseFactures = api.get('/factures');
  const promiseTaches = api.get('/taches/getall');
  const promiseUser = api.get('/users/all');

  const [facturesResponse, tachesResponse, usersResponse] = await Promise.all([promiseFactures, promiseTaches, promiseUser]);

  return [facturesResponse.data.data, tachesResponse.data.data, usersResponse.data.data];
}

/**
 * Permet de modifier les information relié au heure de la semaine
 * @param {*} heureRegulierH temps régulier en heure
 * @param {*} heureRegulierM temps régulier en minute
 * @param {*} currentHeureBanqueTotalH Nombre de temps en banque en heure
 * @param {*} currentHeureBanqueTotalM Nombre de temps en banque en minute
 * @param {*} heureBanquePayeH nombre de temps payé en banque en heure
 * @param {*} heureBanquePayeM ombre de temps payé en banque en minute
 * @param {*} week la semaine
 * @param {*} note la note
 * @param {*} selectedUser selectedUser
 * @return {JSX}
 */
export async function updateWeek(heureRegulierH, heureRegulierM, currentHeureBanqueTotalH, currentHeureBanqueTotalM, heureBanquePayeH, heureBanquePayeM, week, note, selectedUser) {
  let current;
  if (currentHeureBanqueTotalH < 0) {
    current = ((Math.abs(currentHeureBanqueTotalH)) * 60 + parseInt(currentHeureBanqueTotalM)) * -1;
  } else {
    current = currentHeureBanqueTotalH * 60 + parseInt(currentHeureBanqueTotalM);
  };

  const res = await api.put('weeks', {
    heureRegulier: heureRegulierH * 60 + parseInt(heureRegulierM),
    currentHeureBanqueTotal: current,
    heureBanquePaye: heureBanquePayeH * 60 + parseInt(heureBanquePayeM),
    week: week,
    note: note,
    user: selectedUser.value,
  });
  return res;
}

/**
 * Modifier le checkin de l'historique
 * @param {*} id id du checkin
 * @param {*} body information du checkin dans l'historique
 * @return {JSX}
 */
export async function updateCheckinHistory(id, body) {
  const res = await api.put('/startends/history/' + id, {
    note: body.note,
    date: body.date,
    from: body.checkin === null? null : body.checkin.$H + ':' + body.checkin.$m,
    to: body.checkout === null? null : body.checkout.$H + ':' + body.checkout.$m,
    transport: body.transport,
    employer: body.employer,
    extra1: body.extra1,
    extra2: body.extra2,
    extra3: body.extra3,
  });
  return res;
}

/**
 * permet de supprimer une photo
 * @param {*} id id de la photo
 * @param {*} urlparam param dans l'url
 */
export async function deletePhoto(id, urlparam) {
  await api.delete('/photos/' + id + '?chantier=' + urlparam);
}

/**
 * va chercher la liste de fichiers
 * @param {*} urlparam urlparam
 * @return {*}
 */
export async function getFiles(urlparam) {
  const res = await api.get('files?chantier=' + urlparam);
  return res.data.data;
}

/**
 * Va chercher un fichier par son id
 * @param {*} id id
 * @param {*} urlparam urlparam
 * @return {*}
 */
export async function getFilesId(id, urlparam) {
  const pdf = api.get('files/' + id + '?chantier=' + urlparam,
      {
        headers: {
          'Content-type': 'application/json',
        },
        responseType: 'blob',
      });

  const pdfInfo = api.get('files/' + id + '/info');

  const [pdfResponse, pdfInfoResponse] = await Promise.all([pdf, pdfInfo]);

  return {pdf: pdfResponse, pdfInfo: pdfInfoResponse.data};
}

/**
 * Permet de supprimer un fichier
 * @param {*} id id
 * @param {*} urlparam urlparam
 */
export async function deleteFile(id, urlparam) {
  await api.delete('/files/' + id +'?chantier=' + urlparam);
}

/**
 * Permet de recevoir la liste de todolist
 * @param {*} urlparam urlparam
 * @return {*}
 */
export async function getToDoList(urlparam) {
  const res = await api.get('/todolists?chantier=' + urlparam);
  return res.data.data;
}

/**
 * Permet de supprimerune todolist
 * @param {*} id id
 * @return {*}
 */
export async function deleteToDoList(id) {
  const res = await api.delete('/todolists/' + id);
  return res;
}

/**
 * Permet d'update une todolist
 * @param {*} id id
 * @param {*} tacheDescription tacheDescription
 * @param {*} complete complete
 * @return {*}
 */
export async function updateToDoList(id, tacheDescription, complete) {
  const res = await api.put('/todolists/' + id, {
    description: tacheDescription,
    complete: complete,
  });
  return res.data.data;
}

/**
 * Permet d'ajouter une todolist
 * @param {*} tacheDescription tacheDescription
 * @param {*} idChantier idChantier
 * @return {*}
 */
export async function addToDoList(tacheDescription, idChantier) {
  const res = await api.post('/todolists', {
    description: tacheDescription,
    chantier: idChantier,
  });
  return res.data.data;
}

/**
 * Permet d'ajouter une note
 * @param {*} body body
 * @param {*} chantier chantier
 * @return {*}
 */
export async function addNote(body, chantier) {
  const res = await api.post('/notes', {
    note: body.note,
    extra1: body.extra1,
    extra2: body.extra2,
    extra3: body.extra3,
    date: body.selectedDate,
    chantier: chantier,

  });
  return res;
}

/**
 * PErmet de recevoir les notes
 * @param {*} chantier chantier
 * @return {*}
 */
export async function getNotes(chantier) {
  const res = await api.get('notes?chantier=' + chantier);

  return res.data.data;
}

/**
 * Permet de supprimer une note
 * @param {*} id id
 */
export async function deleteNote(id) {
  await api.delete('/notes/' + id);
}

/**
 * Permet de recevoir l'historique d'un projet
 * @param {*} idChantier idChantier
 * @param {*} hasTodolist hasTodolist
 * @param {*} hasCheckin hasCheckin
 * @param {*} hasNote hasNote
 * @param {*} hasPhoto hasPhoto
 * @param {*} hasPDF hasPDF
 * @return {*}
 */
export async function historiqueProjet(idChantier, hasTodolist, hasCheckin, hasNote, hasPhoto, hasPDF) {
  let photoPromise = null;
  let filePromise = null;
  let todolistPromise = null;
  let checkinPromise = null;
  let notePromise = null;

  if (!hasTodolist) {
    todolistPromise = api.get('/todolists?chantier=' + idChantier);
  }

  if (!hasCheckin) {
    checkinPromise = api.get('places/' + idChantier + '/startends');
  }

  if (!hasNote) {
    notePromise = api.get('notes?chantier=' + idChantier);
  }

  if (!hasPhoto) {
    photoPromise = api.get('/photos/' + idChantier);
  }

  if (!hasPDF) {
    filePromise = api.get('files?chantier=' + idChantier);
  }

  const promises = [checkinPromise, notePromise, todolistPromise, photoPromise, filePromise].filter((promise) => promise !== null);

  const res = await Promise.all(promises);

  const dataItems = res.map((item) => item.data.data);

  const combinedArray = [].concat(...dataItems);

  return combinedArray;
}

export async function updateCheckinExtra(id, body) {
  await api.put('/startends/' + id + '/extra', {
    extra1: body.extra1,
    extra2: body.extra2,
    extra3: body.extra3
  });
}

export async function updateFileExtra(id, body) {
  await api.put('/files/' + id + '/extra', {
    extra1: body.extra1,
    extra2: body.extra2,
    extra3: body.extra3
  });
}

export async function updateNoteExtra(id, body) {
  await api.put('/notes/' + id + '/extra', {
    extra1: body.extra1,
    extra2: body.extra2,
    extra3: body.extra3
  });
}

/**
 * Permet de recevoir l'historique d'un projet
 * @param {*} week week
 * @return {*}
 */
export async function getInfoGlobal(week) {

  const formatted = await api.get('startends/weekFormatted?week=' + week);

  let checkinPromise = api.get('startends/all/?week=' + week);

  let todolistPromise = api.get('todolists/all/?week=' + week);

  let notePromise = api.get('notes/all/?week=' + week);

  let photoPromise = api.get('photos/all/?week=' + week);

  let filePromise = api.get('files/all/?week=' + week);


  const promises = [checkinPromise, todolistPromise, notePromise, photoPromise, filePromise].filter((promise) => promise !== null);

  const res = await Promise.all(promises);
  const dataItems = res.map((item) => item.data.data);

  const combinedArray = [].concat(...dataItems);

  combinedArray.sort((a, b) => {
    // First, compare by 'date'
    if (a.date < b.date) return 1;
    if (a.date > b.date) return -1;


    // If dates and user_name are equal, compare by 'user_name'
    if (a.type < b.type) return -1;
    if (a.type > b.type) return 1;

    return 0; // Objects are considered equal
  });


  return [combinedArray, formatted.data];
}


export async function getTachesGraphGlobal(time, selectedEmploye) {
  const res = await api.get('/hourtaches/global/?time=' + time + '&employe=' + selectedEmploye);
  return res;
}

export async function getPhotoUrl(id, idChantier) {
  const res = await api.get('/photos/' + id + '/urlphoto?chantier=' + idChantier);
  return res;
}

